"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDialogButton;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _decorators = require("../utils/propTypes/decorators");

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _iconName = require("../utils/propTypes/iconName");

var _Color = require("../core/Color");

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _Styles = require("../utils/Styles");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _UIIconHolder = _interopRequireDefault(require("../icon/UIIconHolder"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  height: ", ";\n  line-height: normal;\n  position: relative;\n  width: ", ";\n  z-index: ", ";\n\n  &::after {\n    ", ";\n    background: ", ";\n    border-radius: 100%;\n    content: ' ';\n    left: 50%;\n    padding: 20px;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DialogButton = (0, _styledComponents.default)(function (_ref) {
  var __hovered = _ref.hovered,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["hovered"]);
  return _react.default.createElement(_UIClickable.default, rest);
}).attrs({
  className: 'private-modal__control'
}).withConfig({
  displayName: "UIDialogButton__DialogButton",
  componentId: "sc-1tyqiy5-0"
})(_templateObject(), (0, _Styles.setUiTransition)('color'), _colors.OLAF, _sizes.MODAL_CLOSE_BUTTON_SIZE, _sizes.MODAL_CLOSE_BUTTON_SIZE, _sizes.MERCURY_LAYER, (0, _Styles.setUiTransition)('background'), function (props) {
  return props.hovered && (0, _Color.rgba)(_colors.OLAF, 0.1);
}); // fix for IE11 misaligning icons when using UIIconHolder:
// https://git.hubteam.com/HubSpot/UIComponents/issues/5105

var ICON_STYLES = {
  marginLeft: 'auto',
  marginRight: 'auto'
};

function UIDialogButton(props) {
  var IconHolder = props.IconHolder,
      iconName = props.iconName,
      iconSize = props.iconSize,
      rest = (0, _objectWithoutProperties2.default)(props, ["IconHolder", "iconName", "iconSize"]);
  return _react.default.createElement(_HoverProvider.default, props, function (hoverProviderProps) {
    return _react.default.createElement(DialogButton, (0, _extends2.default)({}, rest, hoverProviderProps), _react.default.createElement(IconHolder, {
      innerStyles: ICON_STYLES,
      name: iconName,
      padding: 0,
      size: iconSize
    }));
  });
}

UIDialogButton.propTypes = {
  'aria-label': _propTypes.default.string.isRequired,
  hovered: (0, _decorators.hidden)(_propTypes.default.bool),
  IconHolder: RenderProp.getPropType(_UIIconHolder.default),
  iconName: (0, _iconName.getIconNamePropType)(),
  iconSize: _UIIconHolder.default.propTypes.size
};
UIDialogButton.defaultProps = {
  IconHolder: _UIIconHolder.default,
  iconSize: 'xxs'
};
UIDialogButton.displayName = 'UIDialogButton';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/dialog/UIDialogButton.js
// module id = 394
// module chunks = 5 6 7